"use strict";
import "../services/api_service";
import ZoomableImage from "../accounts_payable/document_browser/zoomable_image";
var DocumentPageAnnotationPage = React.createClass({
  render: function() {
    var page = window.documentPage;
    let accountSettings = {
      tone_adjustments_enabled: true,
      document_annotation_enabled: true
    };
    if (page != null) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        ZoomableImage,
        {
          page,
          annotating: true,
          justSaved: true,
          cropping: false,
          textToHighlight: null,
          disableAnnotations: false,
          annotationOnly: true,
          account: accountSettings,
          zoomLevel: 1,
          toneAdjustments: window.pageAnnotations.toneAdjustments,
          annotationStampUrl: window.annotationStampUrl
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement("h1", null, "Nada");
    }
  }
});
export default DocumentPageAnnotationPage;
